import { styled } from "@mui/material/styles";
import { IconButton, Stack, Typography } from "@mui/material";

export const RootStack = styled(Stack)(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const HomeIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  height: "25px",
  width: "25px",
  "&:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "18px",
  },
}));

export const BreadCrumbText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "400",
  fontSize: "18px",
  "&:hover": {
    textDecoration: "underline",
    cursor: "pointer",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const BreadCrumbItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "18px",
  fontWeight: "400",
  "&:hover": {
    textDecoration: "underline",
    cursor: "pointer",
  },
}));
